import React from 'react';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';

const RelatedSearchPlaceholder = () => {
  return (
    <div className="sui-flex sui-flex-col sui-gap-4">
      <SkeletonLine variant="heading" />
      <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
        <SkeletonBlock aspect="wide" width="100%" height={12} />
      </Skeleton>
    </div>
  );
};

export { RelatedSearchPlaceholder };
